import {h} from 'preact';

/**
 * Component Properties.
 */
interface TableHeadRowProps
{
	className: string;
	role?: string;
	elementRef( element: HTMLTableRowElement ): void;
}

/**
 * Строка папки таблицы планировок.
 */
function TableHeadRow(
	{className, role, elementRef}: TableHeadRowProps,
): JSX.Element
{
	return (
		<tr
			class={className}
			role={role}
			ref={elementRef}
		>
			<th class="image">Планировка</th>
			<th class="room-type">Комнаты</th>
			<th class="square-total">Площадь, м²</th>
			<th class="section">Секция</th>
			<th class="floor">Этаж</th>
			<th class="total-cost">Стоимость</th>
			<th class="other">&nbsp;</th>
		</tr>
	);
}

/**
 * Module.
 */
export {
	TableHeadRow as default,
	TableHeadRowProps,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/TableHeadRow.tsx